import { DataBean } from "../DataBean";

export class CompetitionType extends DataBean {


    public async getCompetitionTypeCatalog(): Promise<any> {
        return this.getCustomService("PeopleArt", "java.util.List_getCompetitionTypeCatalog_Number", [null]);
    }
}